<mat-card *appHasRoles="['admin', 'manager', 'agent', 'compliance']" class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Annual Fees</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
      <label fxFlex="20" class="secondary">Card</label>
      <label fxFlex="20" class="secondary">Date</label>
      <label fxFlex="16" class="secondary">Due Date</label>
      <label fxFlex="15" class="secondary">Status</label>
      <label fxFlex="15" class="secondary">Amount</label>
      <label fxFlex="15" class="secondary">Paid</label>
    </div>
    <div id="scroll">
      <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let annualFee of annualFees" >
        <label class="" fxFlex="20" >{{ annualFee.card ? annualFee.card.token : '' }}</label>
        <label class="" fxFlex="20" >{{ annualFee.creationDate | date: "dd.MM.yyyy" }}</label>
        <label class="" fxFlex="20" >{{ annualFee.dueDate | date: "dd.MM.yyyy" }}</label>
        <label class="" fxFlex="16" >
          {{ annualFee.state }}
        </label>
        <label class="" fxFlex="15" >{{ annualFee.amountPaid }} / {{ annualFee.amount }}</label>
        <label class="" fxFlex="15" >{{ annualFee.isPaid ? '🟢':'⚪️' }}</label>
      </div>
    </div>
  </mat-card-content>
</mat-card>
